import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import { presentationOptions } from '@/constants/states';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import TableWrapper from '@/components/table/TableWrapper';
import VocabulariesTableHeader from './VocabulariesTableHeader';
import VocabulariesFilters from '../containers/VocabulariesFilters';
import VocabulariesTableRows from '../containers/VocabulariesTableRows';

const VocabulariesTable = ({
  category,
  currentPage,
  fetchData,
  pageCount,
  readErrors,
  readStatus,
  pageSize,
  total,
  vocabularies,
  togglePresentation,
}) => {
  const { items, pageNumber } = fitToPage(vocabularies, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-vocabularies-table">
        <VocabulariesTableHeader readErrors={readErrors} readStatus={readStatus}>
          {togglePresentation && (readStatus !== states.PENDING) && (
          <ToggleCardsButton
            display={presentationOptions.TABLE}
            disabled={readStatus === states.PENDING}
            onClick={() => togglePresentation(category, presentationOptions.CARDS)}
          />
          )}
          <VocabulariesFilters category={category} className="aridhia-table-filter" />
        </VocabulariesTableHeader>
        <Table.Body>
          <VocabulariesTableRows category={category} items={items} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="vocabulary"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="font"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default VocabulariesTable;
